(()=>{
const q=s=>document.querySelector(s),esc=s=>String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const departmentParams=new URLSearchParams(location.search);
let selected=departmentParams.get('department')||(departmentParams.get('group')==='Chemicals & Lubes'?'Chemicals':'');
const nav=window.BraapNavigation;
const labels=Object.fromEntries([['','All Categories'],...nav.departmentSections.flatMap(section=>section.keys.map(key=>[key,nav.departmentLabel(key)]))]);
// Directory presentation only: retain the original collection routes and filters.
// Match shopper vocabulary without changing category names or collection routes.
function categorySearch(query){
 const normalize=value=>String(value).normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
 const stem=word=>word.length>4&&word.endsWith('ies')?word.slice(0,-3)+'y':word.length>3&&word.endsWith('s')&&!word.endsWith('ss')?word.slice(0,-1):word;
 const words=value=>normalize(value).split(/\s+/).filter(Boolean).map(stem);
 const stop=new Set(['a','an','the','and','or','for','of','with','by','to','my','i','need','find','looking','buy']);
 const aliases=[
  ['tire','tyre'],['goggle','eyewear'],['helmet','lid'],
  ['lube','lubricant','lubrication'],['antifreeze','coolant'],
  ['sprocket','cog'],['handlebar','bar'],['muffler','silencer'],
  ['jersey','shirt'],['boot','footwear'],['pants','pant','trouser'],
  ['backpack','rucksack'],['wrench','spanner'],['gps','navigation'],
  ['communicator','intercom'],['protection','protector','guard','armor','armour'],
  ['carb','carburetor','carburettor'],['petcock','fuel tap'],
  ['radiator','cooling'],['shock','suspension'],['disc','disk','rotor'],
  ['decal','sticker','graphic'],['plastic','bodywork'],['peg','footpeg'],
  ['saddle','seat'],['pannier','saddlebag','luggage'],['windscreen','windshield'],
  ['hoodie','sweatshirt'],['beanie','cap','hat'],['underwear','undergarment'],
  ['rainwear','waterproof'],['neckbrace','neck brace'],
  ['allen','hex'],['screwdriver','screw driver'],['multitool','multi tool'],
  ['tie down','tiedown','tie-down'],['ratchet','socket'],
  ['threadlocker','loctite','thread lock'],['degreaser','cleaner'],
  ['premix','2 stroke','two stroke'],['4 stroke','four stroke'],
  ['gearbox','transmission'],['gas','gasoline','petrol','fuel'],
  ['tacho','tachometer','rpm'],['speedo','speedometer'],['voltmeter','voltage'],
  ['hourmeter','hour meter'],['satnav','gps','navigation'],
  ['turn signal','indicator','blinker'],['taillight','tail light'],
  ['headlight','headlamp'],['sparkplug','spark plug'],['kickstand','stand'],
  ['a arm','aarm','control arm'],['handguard','hand guard'],['skidplate','skid plate']
 ];
 const tokens=[...new Set(words(query).filter(word=>!stop.has(word)))];
 const expanded=tokens.map(word=>new Set([word,...aliases.filter(group=>group.includes(word)).flat()]));
 const phraseAliases=aliases.filter(group=>group.some(alias=>(' '+normalize(query)+' ').includes(' '+normalize(alias)+' '))).flat();
 const close=(a,b)=>{
  if(a.length<5||b.length<5||Math.abs(a.length-b.length)>1)return false;
  if(a.length===b.length){const diff=[...a].map((c,i)=>c!==b[i]?i:-1).filter(i=>i>=0);return diff.length===1||(diff.length===2&&diff[1]===diff[0]+1&&a[diff[0]]===b[diff[1]]&&a[diff[1]]===b[diff[0]]);}
  const shorter=a.length<b.length?a:b,longer=a.length<b.length?b:a;
  let i=0;while(i<shorter.length&&shorter[i]===longer[i])i++;
  return shorter.slice(i)===longer.slice(i+1);
 };
 return (text,allWords=false)=>{
  if(!tokens.length)return true;
  const candidates=words(text);
  const match=group=>[...group].some(word=>candidates.some(candidate=>candidate===word||(word.length>=3&&candidate.startsWith(word))||(!allWords&&close(word,candidate))));
  // Product titles require all query words; category labels also allow partial matches.
  if(allWords)return expanded.every(match);
  return expanded.some(match)||phraseAliases.some(alias=>(' '+candidates.join(' ')+' ').includes(' '+words(alias).join(' ')+' '));
 };
}
let searchProducts=[],catalogSearchLoading=false,catalogSearchLoaded=false;
function loadSearchProducts(){
 if(catalogSearchLoading||catalogSearchLoaded)return;
 catalogSearchLoading=true;
 fetch(window.BraapThemeAssets['category-search-products.json']).then(response=>{if(!response.ok)throw new Error('Catalog unavailable');return response.json()}).then(products=>{
  searchProducts=products.filter(p=>!p.hidden);catalogSearchLoaded=true;
 }).catch(()=>{}).finally(()=>{catalogSearchLoading=false;draw()});
}
function matchingProductCategories(matches,term){
 const found=new Set();if(!term)return found;
 searchProducts.forEach(product=>{
  if(!matches(product.title,true))return;
  (product.categories||[]).forEach(category=>found.add('|'+category));
  Object.entries(product.categoriesByDepartment||{}).forEach(([department,categories])=>{
   categories.forEach(category=>found.add(department+'|'+category));
  });
 });
 return found;
}
function draw(){
 const nav=window.BraapNavigation,term=q('#category-search').value.trim().toLowerCase();
 const matches=categorySearch(term);
 const productCategories=matchingProductCategories(matches,term);
 const sections=nav.directorySections(selected);
 let total=0;const target=q('#directory-groups');target.replaceChildren();target.dataset.department=selected;target.classList.toggle('apparel-directory',selected==='Apparel');
 const visibleSections=[];
 sections.forEach(section=>{
  const title=section.querySelector('h3')?.textContent||'';
  const links=[...section.querySelectorAll('a')];
  links.forEach(a=>{
   const params=new URL(a.href,location.href).searchParams;
   const category=params.get('category')||a.querySelector('span')?.textContent||a.textContent;
   a.hidden=!(matches(title+' '+category+' '+(a.closest('.apparel-subgroup,.directory-subgroup')?.querySelector('h4')?.textContent||''))||productCategories.has((params.get('department')||'')+'|'+category));
  });
  section.querySelectorAll('.apparel-subgroup,.directory-subgroup').forEach(g=>{
   g.hidden=![...g.querySelectorAll('a')].some(a=>!a.hidden);
  });
  const visible=links.filter(a=>!a.hidden).length;if(!visible)return;
  total+=visible;section.classList.add('directory-group');visibleSections.push(section);
 });
 if(selected&&visibleSections.length>1){
  const card=document.createElement('section'),columns=document.createElement('div');
  card.className='directory-group department-category-card';columns.className='department-category-columns';
  card.append(columns);visibleSections.forEach(section=>{section.classList.remove('directory-group');section.classList.add('department-category-section');columns.appendChild(section)});target.appendChild(card);
 }else visibleSections.forEach(section=>{const heading=section.querySelector(':scope>h3');if(selected&&heading?.textContent.trim()===(labels[selected]||''))heading.remove();if(selected)section.classList.add('department-single-card');target.appendChild(section)});
 q('#directory-title').textContent=labels[selected]||'All Categories';q('#category-count').textContent=total+' category '+(total===1?'link':'links');q('#directory-empty').hidden=total>0;document.querySelectorAll('[data-dept]').forEach(b=>b.setAttribute('aria-pressed',b.dataset.dept===selected));
}

q('#category-search').addEventListener('focus',loadSearchProducts);
q('#category-search').addEventListener('input',loadSearchProducts);
window.BraapNavigation.ready.then(()=>{
 if(!(selected in labels))selected='';
 const button=d=>`<button data-dept="${d}" aria-pressed="false">${esc(labels[d])}</button>`;
 q('#department-list').innerHTML=button('')+nav.departmentSections.map(section=>`<section class="directory-departments"><h3>${esc(section.label)}</h3>${section.keys.filter(d=>nav.groups(d).length).map(button).join('')}</section>`).join('');draw();
}).catch(()=>q('#directory-groups').textContent='Categories could not load. Please refresh.');
document.addEventListener('click',e=>{const b=e.target.closest('[data-dept]');if(!b)return;selected=b.dataset.dept;history.replaceState(null,'','/collections?view=braap-categories'+(selected?'&department='+encodeURIComponent(selected):''));q('#category-search').value='';draw();q('.directory-layout').scrollIntoView({behavior:'smooth',block:'start'})});q('#category-search').oninput=draw;
})();
